<template>
    <div class="pt-2 mt-2 border card shadow" style="border-radius: 20px">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center w-full mb-2" style="margin-bottom: 5em!important;">
          <div>
            <div class="text-dark" style="font-weight: 500; font-size: 18px; line-height: 24px;">Gender Survey</div>
          </div>
        </div>
  
        <vue-apex-charts
          type="pie"
          height="300"
          :options="chartOptions"
          :series="series"
        />
      </div>
    </div>
  </template>
  
  <script>
  import { 
    BCol, 
    BRow, 
    BCard, 
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BAvatar,
    BMedia,
    BMediaAside,
    BMediaBody, 
    BFormGroup
  } from 'bootstrap-vue'
  
  import VueApexCharts from 'vue-apexcharts'
  import vSelect from 'vue-select'
  
  
  export default {
    name: "PatientByGenderChart",
    components: {
      VueApexCharts,
      BCol, 
      BRow,
      BCardHeader, 
      BCardTitle, 
      BCardText,
      BCard,
      BCardBody,
      BAvatar,
      BMedia, 
      BMediaAside, 
      BMediaBody,
      BFormGroup,
  
      vSelect,
    },
    props: {
      series: {
        type: Array,
        default: () => [],
      },
      chartOptions: {
        type: Object,
        default: null,
      },
    },
  }
  </script>

